import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  dataPreview: {
    id: 'ZruuL1',
    description: 'Data from csv file',
    defaultMessage: 'Data Preview: {current} of {all}',
  },
});
